import { render, staticRenderFns } from "./CollectionContentRowItem.vue?vue&type=template&id=b435ed5a&scoped=true&"
import script from "./CollectionContentRowItem.vue?vue&type=script&lang=js&"
export * from "./CollectionContentRowItem.vue?vue&type=script&lang=js&"
import style0 from "./CollectionContentRowItem.vue?vue&type=style&index=0&id=b435ed5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b435ed5a",
  null
  
)

export default component.exports